<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="campus_id"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('campus')">
                            <campus-selectbox v-model="form.campus_id"
                                              :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="name" rules="required" v-slot="{valid, errors}">
                        <b-form-group  :label="$t('name')">
                            <b-form-input v-model="form.name" :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="surname" rules="required" v-slot="{valid, errors}">
                        <b-form-group  :label="$t('surname')">
                            <b-form-input v-model="form.surname" :state="errors[0] ? false : null"/>
                        </b-form-group>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="mobile_tel" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('mobile_number')">
                            <b-form-input v-model="form.mobile_tel"
                                          v-mask="'### ### ## ##'"
                                          :state="errors[0] ? false : null" />
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="email"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('email')">
                            <b-form-input v-model="form.email"
                                          type="email"
                                          :placeholder="$t('email')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="national_id"
                                        rules="required"
                                        v-slot="{ valid, errors }">
                        <b-form-group :label="$t('national_id')">
                            <b-form-input maxlength="11"
                                          v-model="form.national_id"
                                          :placeholder="$t('national_id')"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="birthdate" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('birthdate')">
                            <select-date v-model="form.birthdate" :readonly="false"
                                         :validation-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="city_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('city_id')">
                            <city-selectbox v-model="form.city_id"></city-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="district_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('district_name')">
                            <district-outline-selectbox
                                :city_id="form.city_id"
                                v-model="form.district_id"
                                :validateError="errors[0]">
                            </district-outline-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="school" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('school')">
                            <university-selectbox
                                v-model="form.school"
                                :validate-error="errors[0]"></university-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import PromotionalProcessService from "@/services/PromotionalProcessService";
    import CampusSelectbox from "@/components/interactive-fields/CampusSelectbox.vue";
    import CitySelectbox from "@/components/interactive-fields/CitySelectbox.vue";
    import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox.vue";
    import UniversitySelectbox from "@/components/interactive-fields/UniversitySelectbox.vue";


    export default {
        components: {
            DistrictOutlineSelectbox,
            UniversitySelectbox,
            CitySelectbox,
            CampusSelectbox,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                form: {
                    campus_id: null,
                    name: null,
                    surname: null,
                    mobile_tel: null,
                    email: null,
                    national_id: null,
                    birthdate: null,
                    city_id: null,
                    district_id: null,
                    school: null,
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PromotionalProcessService.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;

                    PromotionalProcessService.update(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            }
        }
    }
</script>
